module.exports = __webpack_public_path__ + "static/media/csv.2bfcdd0c.svg";